<template>
  <div class="h-screen overflow-hidden">
    <van-nav-bar :title="t('registroDeDeposito.title')" class="custom-nav-bar" :border="false">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="mt-[15px] mx-[20px]">
      <div class="bonus-table-header">
        <div class="date-select">
          <Border radius="4px" borderWidth="2px">
            <div class="date-btn w-full h-[40px] flex items-center justify-between" @click="showOptions = !showOptions">
              {{ sourceOptions[selectedDate].label }}
              <span :class="['arrow', showOptions ? 'up' : 'down']"></span>
            </div>
          </Border>

          <div v-if="showOptions" class="date-options bg-[#005E4B]">
            <div class="date-options-grid">
              <button v-for="(item, idx) in sourceOptions" :key="item.value"
                :class="['option-btn', { active: idx === selectedDate }]" @click="selectDate(idx)">
                {{ item.label }}
              </button>
            </div>
          </div>
        </div>
        <div class="bonus-value">
          {{ t('bonusRecord.totalBonus') }}: <span class="yellow">{{ numberFormat(totalAmount) }}</span>
        </div>
      </div>
    </div>
    <div ref="scrollRef" class="deposit-list h-[calc(100vh-160px)] overflow-y-auto">

      <div v-if="tableData.length">
        <div v-for="item in tableData" :key="item.orderId" class="deposit-card">
          <div class="card-header">
            <span class="type">{{ t('bonusRecord.bonus') }} : {{ numberFormat(item.bound) }}</span>
            <span class="amount" v-if="item.status == 1">
              {{ getAuditStatusInfo(item.status).text }}
            </span>
          </div>
          <div class="card-progress">
            <div>
              {{ t('bonusRecord.completedBet') }} / {{ t('bonusRecord.shouldBet') }} : {{
                numberFormat(item.completeAmount) }}
              / {{ numberFormat(item.amount) }}
            </div>
          </div>
          <div class="flex justify-between">
            <div class="card-order">
              {{ t('bonusRecord.source') }} : {{ getSourceName(item.groupType) }}
            </div>
            <div class="card-time" v-if="item.expireTime">{{ t('bonusRecord.validUntil') }} {{
              dayjs(item.expireTime).format('YYYY-MM-DD HH:mm')
            }}
            </div>
          </div>


          <!-- <div class="card-status" :class="getStatusInfo(item.status).class">
            {{ getStatusInfo(item.status).text }}
          </div> -->
        </div>
      </div>
      <div v-else>
        <div class="empty-wrap">
          <div class="flex justify-center items-center">
            <img :src="getAssetsFile('home/No_record@2x.png')" alt=""
              class="max-h-[84px] max-w-[106.5px] w-auto h-auto">
          </div>
          <div class="empty-text">{{ t('registroDeDeposito.noRecords') }}</div>
        </div>
      </div>

    </div>
  </div>
</template>
<script setup lang="ts">
import { Border } from "@/components/Border"
import { useRouter } from 'vue-router'
import { ref, computed, onMounted } from 'vue'
import dayjs from 'dayjs'
import * as GameApi from '@/api/game'
import { numberFormat } from '@/utils/formatter'
import { useClipboard } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'
import { formatDateTime } from '@/utils/date'
import { Button } from '@/components/Button'
const router = useRouter()
const { t } = useI18n()
const scrollRef = ref<HTMLElement | null>(null)
const showOptions = ref(false)
const now = new Date()
const pageNo = ref(1)
const pageSize = ref(10) // 这里不用手动改，fetchData里会自动赋值
const total = ref(0)     // 总条数
const totalPage = ref(0)
const selectedDate = ref(0)
const tableData = ref([])
const today = getStartOfDay(now)

const VITE_symbol = import.meta.env.VITE_SYMBOL
const sourceOptions = [
  { label: t('bonusRecord.allSource'), value: null },
  { label: t('bonusRecord.recharge'), value: 1 },
  { label: t('bonusRecord.activity'), value: 2 },
  { label: t('bonusRecord.commission'), value: 3 }
]

const getSourceName = (source: number) => {
  return sourceOptions.find(item => item.value === source)?.label
}
// 获取审计状态信息
const getAuditStatusInfo = (status: number) => {
  const auditStatusMap = {
    0: { text: t('wallet.chargebackRecord.auditStatus.pending'), class: 'pending' },
    1: { text: t('wallet.chargebackRecord.auditStatus.processing'), class: 'processing' },
    2: { text: t('wallet.chargebackRecord.auditStatus.approved'), class: 'success' }
  }
  return auditStatusMap[status] || { text: t('wallet.chargebackRecord.auditStatus.unknown'), class: 'timeout' }
}
// 格式化为 yyyy-MM-dd 00:00:00
function formatDate(date: Date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d} 00:00:00`
}
// 获取当天0点
function getStartOfDay(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
}
function selectDate(idx: number) {
  selectedDate.value = idx
  showOptions.value = false
  pageNo.value = 1 // 切换时间时重置到第一页
  tableData.value = []
  fetchData() // 重新获取数据
}
const totalAmount = ref(0)
const onClickLeft = () => {
  router.back()
}


// 修复：将 useClipboard 移到顶层
const { copy: copyToClipboard } = useClipboard()

function copyOrder(orderNo: string) {
  // 修复：直接使用顶层的 copyToClipboard
  copyToClipboard(orderNo)
    ; (window as any).$toast(t('registroDeDeposito.copySuccess'))
}


// 添加获取数据的方法
const fetchData = async () => {
  const response = await GameApi.auditRecord(params.value)
  if (response.data) {
    totalAmount.value = response.data.amount || 0
    tableData.value = [...tableData.value, ...response.data.pageResult.list]
    total.value = response.data.pageResult.total || 0
    totalPage.value = response.data.pageResult.totalPages || 0
  }
}

// 将 params 提取到外面，方便后续滚动加载使用
const params = computed(() => ({
  pageNo: pageNo.value,
  pageSize: pageSize.value,
  groupType: sourceOptions[selectedDate.value].value,
  invalid: true
}))

// 添加加载下一页的方法
const loadNextPage = async () => {
  if (tableData.value.length >= total.value || params.value.pageNo >= totalPage.value) {
    return // 已经加载完所有数据
  }

  pageNo.value += 1
  try {
    fetchData()
  } catch (error) {

    pageNo.value -= 1 // 加载失败时回退页码
  }
}
// 添加滚动监听
const handleScroll = () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const windowHeight = window.innerHeight
  const documentHeight = document.documentElement.scrollHeight

  // 当滚动到距离底部100px时触发加载
  if (scrollTop + windowHeight >= documentHeight - 100) {
    loadNextPage()
  }
}

// 简化的状态配置
const statusMap = {
  0: { text: t('registroDeDeposito.status.recharging'), class: 'success' },
  1: { text: t('registroDeDeposito.status.success'), class: 'success' },
  2: { text: t('registroDeDeposito.status.failed'), class: 'fail' },
  3: { text: t('registroDeDeposito.status.refund'), class: 'fail' }
}

// 获取状态信息
const getStatusInfo = (status: number) => {
  return statusMap[status] || { text: t('registroDeDeposito.status.unknown'), class: 'timeout' }
}

onMounted(() => {
  fetchData()
  scrollRef.value?.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  scrollRef.value?.removeEventListener('scroll', handleScroll)
})
</script>
<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.bonus-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.date-select {
  position: relative;
  width: 160px;
}

.date-btn {
  // background: getPath('activity/historyDateSelectBorderBg.png') no-repeat;
  // background-size: 100% 100%;
  color: #fff;
  // border-radius: 8px;
  padding: 0 18px 0 12px;
  font-size: 16px;
  font-weight: 500;
  outline: none;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  line-height: normal;
  white-space: nowrap;
}

.empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 115px 0 0 0;
}

.empty-text {
  color: #ADB1B0;
  font-size: 11px;
  margin-top: 21px;

}

.arrow {
  display: inline-block;
  margin-left: 6px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #40b665;
  transition: transform 0.2s;
}

.arrow.up {
  transform: rotate(180deg);
}

.arrow.down {
  transform: rotate(0deg);
}

.date-options {
  position: absolute;
  top: 45px;
  left: 0;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  z-index: 10;
  padding: 16px 18px;
  min-width: 340px;
  width: max-content;
}

.date-options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
}

.option-btn {
  background: transparent;
  border: 1px solid #40b665;
  color: #40b665;
  border-radius: 8px;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  min-width: 120px;
  text-align: center;
  white-space: nowrap;
  width: 100%;
  box-sizing: border-box;
}

.option-btn.active,
.option-btn:hover {
  background: linear-gradient(90deg, #40b665 0%, #1ecb7b 100%);
  color: #fff;
  border: 1px solid #40b665;
}

.bonus-value {
  width: 40%;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.bonus-value .yellow {
  color: #27D48B;
}

.bonus-table {
  margin-top: 24px;
}

.deposit-list {
  margin: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.deposit-card {
  background: #005142;
  border-radius: 10px;
  padding: 18px 16px 14px 16px;
  position: relative;
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  color: #fff;
}

.type {
  font-size: 14px;
  font-weight: bold;
}

.card-header .amount {
  color: #FCEE40;
  font-size: 16px;
}

.card-progress {
  color: #34B388;
  font-size: 13px;
  margin-top: 20px;
}

.card-time {
  color: #34B388;
  font-size: 13px;
  margin-top: 20px;
}

.card-order {
  color: #34B388;
  font-size: 13px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.copy-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.card-status.success {
  color: #27D48B;
  font-size: 12px;
  position: absolute;
  right: 16px;
  bottom: 14px;
}

.card-status.fail {
  color: #ff4d3b;
  font-size: 12px;
  position: absolute;
  right: 16px;
  bottom: 14px;
}
</style>


<route lang="json5">
    {
      name: 'bonusRecord',
      meta: {
        title: 'Registro de Depósito',
        i18n: 'menus.bonusRecord'
      },
    }
</route>
